/**
 * The id of a camera. It has a module of its own because devices.ts imports notifications.ts,
 * and both read it.
 */

import { z } from 'zod';

/**
 * A camera's device id, unique across servers, in the 8-4-4-4-12 hex form. The media_server's
 * ids carry no RFC 9562 version digit, so only the form is checked.
 */
export const DeviceIdSchema = z.guid();

/**
 * Refuses `field` of an object that holds a device id only for some kinds: where `isDevice`
 * says the object is of such a kind, the field must be a device id. The issue names the field.
 */
export function checkDeviceIdOf<T extends object>(
    field: keyof T & string, isDevice: (value: T) => boolean,
): z.core.CheckFn<T> {
    return (payload): void => {
        const value = payload.value[field];
        if (isDevice(payload.value) && !DeviceIdSchema.safeParse(value).success) {
            payload.issues.push({
                code: 'custom',
                message: 'Invalid device id',
                input: value,
                path: [field],
            });
        }
    };
}
